module.exports = __webpack_public_path__ + "img/blog-67 (1).f9c07866.jpg";